import React from 'react';
import { bool, func, number, object, shape, string } from 'prop-types';
import GeoTableModifiers from '../../GeoTableModifiers/GeoTableModifiers';
import EmployeeFilter from '../../EmployeeFilter/EmployeeFilter';
import { numberWithCommas } from 'ps-components/lib/formatters';
import './ApplyHeader.scss';

const EMPLOYEE_STRATEGY_TEXT = 'Apply Geo Differentials to market composites and ranges';

ApplyHeader.propTypes = {
  compareWithLocation: string,
  groupByJobFamily: bool,
  handleCompareWithLocationChange: func,
  hasData: bool,
  searchInputRef: object,
  searchPayScaleLocations: func,
  setSearchText: func,
  showApplyGeo: bool,
  showCompanyLocations: bool,
  showGrouped: bool,
  showPayScaleLocations: bool,
  showUnmatchedOnly: bool,
  supportedLocations: shape({ string }),
  toggleUnmatchedLocations: func,
  totalEmployees: number,
  totalLocations: number
};

function ApplyHeader(props) {
  const {
    compareWithLocation,
    groupByJobFamily,
    handleCompareWithLocationChange,
    hasData,
    searchInputRef,
    searchPayScaleLocations,
    setSearchText,
    showApplyGeo,
    showCompanyLocations,
    showGrouped,
    showPayScaleLocations,
    showUnmatchedOnly,
    supportedLocations,
    toggleUnmatchedLocations,
    totalEmployees,
    totalLocations
  } = props;

  function getHeaderStats() {
    const employees = numberWithCommas(totalEmployees);
    const locations = numberWithCommas(totalLocations);

    return `Impact ${employees} employees in ${locations} locations`;
  }

  return (
    <div className="apply-header__container">
      <div className="apply-header__title-row">
        <div>
          <div className="apply-header_row">
            <div className="apply-header__title">{EMPLOYEE_STRATEGY_TEXT}</div>
          </div>
          <div className="apply-header_row">
            <div className="apply-header__stats">{getHeaderStats()}</div>
          </div>
        </div>

        <div className="apply-header__filter-section">
          <EmployeeFilter />
        </div>
      </div>

      <GeoTableModifiers
        compareWithLocation={compareWithLocation}
        groupByJobFamily={groupByJobFamily}
        handleCompareWithLocationChange={handleCompareWithLocationChange}
        hasData={hasData}
        searchPayScaleLocations={searchPayScaleLocations}
        searchInputRef={searchInputRef}
        setSearchText={setSearchText}
        showApplyGeo={showApplyGeo}
        showCompanyLocations={showCompanyLocations}
        showGrouped={showGrouped}
        showPayScaleLocations={showPayScaleLocations}
        showUnmatchedOnly={showUnmatchedOnly}
        supportedLocations={supportedLocations}
        toggleUnmatchedLocations={toggleUnmatchedLocations}
      />
    </div>
  );
}

export default ApplyHeader;
